import { render } from "./CustomButton.vue?vue&type=template&id=8b7eff10&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=8b7eff10&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7eff10"]])

export default __exports__